/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Merge_Prev_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Unable to merge with previous event" |
*
* @param {Shortcut_Keys_Merge_Prev_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_merge_prev_failed_toast = /** @type {((inputs?: Shortcut_Keys_Merge_Prev_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Merge_Prev_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de fusionner avec l'evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführung mit vorherigem Ereignis nicht möglich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile unire con l'evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось объединить с предыдущим событием.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede fusionar con el evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法与之前的事件合并")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のイベントと統合できません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछली घटना के साथ विलय करने में असमर्थ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível mesclar com o evento anterior.")
	return /** @type {LocalizedString} */ ("Unable to merge with previous event")
});